import { render, staticRenderFns } from "./IconArrowDownSquare.vue?vue&type=template&id=46642182&scoped=true&"
import script from "./IconArrowDownSquare.vue?vue&type=script&lang=js&"
export * from "./IconArrowDownSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46642182",
  null
  
)

export default component.exports